
/**
 * @file main.tsx
 * @version 2.0.0
 * @description
 * The main entry point for the React application.
 *
 * @changelog
 * - 2.0.0 (2025-08-06): Removed incorrect i18nPromise import.
 * - 1.0.0 (2024-03-12): Initial version.
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './i18n'; // Initializes i18next
import { functions } from './firebase'; // Import the functions instance
import { httpsCallable } from 'firebase/functions'; // Import httpsCallable

// TEMPORARY: Expose a function to the window for a one-time admin task.
// This function will be called from the browser console.
(window as any).grantSuperAdmin = async () => {
  try {
    const grantSuperAdminCallable = httpsCallable(functions, 'onCallGrantSuperAdmin');
    const result = await grantSuperAdminCallable();
    console.log('Function called successfully:', result);
    return result;
  } catch (error) {
    console.error('Error calling function:', error);
    throw error;
  }
};


ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
